import React from 'react'
import "./cta.css"

const CTA = () => {
  return (
    <div className="gpt3__cta section__margin">
      <div className="gpt3__cta-content">
        <p>Request Early Access to Get Started</p>
        <h1>Register today & start exploring the endless possiblities.</h1>
      </div>
      <button>Get Started</button>
    </div>
  )
}

export default CTA